import _ from 'lodash'
import { useMemo } from 'react'
import useAuth from '../../contexts/AuthContext/useAuth'
import { useGetTeamsV2Query } from '../../generated/api'

export function useSubTeams({
  parentTeamId,
}: {
  parentTeamId: string | undefined
}) {
  const { user } = useAuth()
  const gameId = user?.info.gameId

  const { data: subTeams } = useGetTeamsV2Query(
    { gameId: gameId || '', parentTeamId },
    { enabled: !!gameId && !!parentTeamId }
  )

  const options = useMemo(
    () =>
      (subTeams?.getTeamsV2 || []).map((team) => ({
        label: team.name,
        id: team.teamId,
      })),
    [subTeams]
  )

  const sortedOptions = useMemo(() => _.sortBy(options, 'label'), [options])
  return sortedOptions
}
